import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as classnames from 'classnames';
import * as React from 'react';
import { memo, useMemo } from 'react';
// import {
//     ContextMenu,
//     ContextMenuTrigger,
//     ContextMenuTriggerProps,
//     MenuItem,
// } from 'react-contextmenu';
import { LongPressButton } from 'console/dashboards/zth/control-block/longpress';
import { UniversalMenu } from 'shared/components/menu';
import { useAnchor } from 'shared/hooks/utils';
export const ControlButton = memo(function ControlButton({ label, iconclass, active, confirmed, loading, has_menu, disabled, addClass, square = true, dialog, color, contextmenu, backgroundStyle, onClick, onDisabledClick, children, }) {
    let effectiveOnClick = onClick;
    if (loading) {
        effectiveOnClick = null;
    }
    else {
        if (disabled) {
            effectiveOnClick = onDisabledClick;
        }
    }
    const [anchor, openMenu, closeMenu] = useAnchor();
    const menu_items = useMemo(() => (contextmenu ?? []).map(({ title, action }) => ({
        label: title,
        onClick: action,
    })), [contextmenu]);
    return (_jsxs("div", { style: { display: 'inline-block', position: 'relative' }, children: [_jsx(LongPressButton, { enabled: true, square: square, onClick: effectiveOnClick ?? undefined, style: backgroundStyle ?? {}, className: classnames(addClass, 'ui-control-button-background', {
                    active: active,
                    confirmed: confirmed,
                    disabled: disabled,
                    loading: loading,
                    'ui-control-button-square-margins': square,
                    'longpress-cyan': active,
                    'longpress-blue': confirmed,
                }), children: _jsxs("div", { className: classnames('ui-control-button', 'visible', {
                        'ui-square-control-button': square,
                        active: active,
                        confirmed: confirmed,
                        loading: loading,
                        has_menu: has_menu,
                    }), children: [loading && (_jsx("div", { className: "ui-control-button-loading ui-icon-control-button-loading" })), _jsx("div", { className: classnames('ui-control-button-icon', iconclass) }), _jsx("div", { className: "ui-control-button-label", style: { color }, children: label }), children] }) }), has_menu && (_jsx("div", { className: classnames('ui-control-button-menu-button ui-icon-control-button-menu-button', { active: active }, { not_square: !square }), onTouchStart: (ev) => {
                    ev.stopPropagation();
                    openMenu(ev);
                }, onClick: (ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    openMenu(ev);
                } })), _jsx(UniversalMenu, { menu_items: menu_items, opened: !!anchor, anchor: anchor, onClose: closeMenu }), dialog] }));
});
